interactions = []
scores       = {}

track = (event, done = ->) ->

trackView = (data, done = ->) ->

trackInteraction = (data, done = ->) ->
  interactions.push(data)
  if data?.configuration?.nb_stars? or data?.configuration?.weighting?
    name   = data.name
    total  =
      if data.configuration.weighting?
        data.configuration.weighting
      else
        data.configuration.nb_stars
    earned =
      if data.game
        { max, min } = data.slideData.game.stars

        if data.configuration.weighting?
          # Calculate the scaled weighting based on score
          if data.score.total < min
            0
          else if data.score.total > max
            total
          else
            Math.floor((data.score.total - min) / ((max - min) / total))

        else
          data.nb_stars_earned
      else
        if data.correct then total else 0
    scores[name] = { earned, total }

trackScoreAndCompletion = (minScaledScore = 0, incompleteOnFail = false) ->
  _scores = (v for k, v of scores) or []
  _earned = _scores.reduce ((result, s) -> result + s.earned), 0
  _total  = _scores.reduce ((result, s) -> result + s.total), 0
  _scaled = _earned * 100.0 / _total

  pipwerks.SCORM.set("cmi.core.score.raw", _earned)
  pipwerks.SCORM.set("cmi.core.score.min", 0)
  pipwerks.SCORM.set("cmi.core.score.max", _total)

  # Scorm 1.4 standards specificly for SABA
  pipwerks.SCORM.set("cmi.score.raw", _earned)
  pipwerks.SCORM.set("cmi.score.min", 0)
  pipwerks.SCORM.set("cmi.score.max", _total)

  if _total is 0 or _scores.length is 0 or _scaled >= minScaledScore
    # Scorm 1.4 standards specificly for SABA
    pipwerks.SCORM.set("cmi.completion_status", "completed")
    console.log("SCORM lesson completed")
    pipwerks.SCORM.set("cmi.core.lesson_status", "passed")
  else
    failStatus = if incompleteOnFail then "incomplete" else "failed"
    # Scorm 1.4 standards specificly for SABA
    pipwerks.SCORM.set("cmi.completion_status", "incomplete")
    
    pipwerks.SCORM.set("cmi.core.lesson_status", failStatus)
    


trackEvent = ->
startTracking = ->
stopTracking = ->

commands = (next) ->
  { trackInteraction,
    trackView,
    startTracking,
    stopTracking,
    trackEvent,
    trackScoreAndCompletion }

module.exports = { type: "analytics", commands }
